import { useSelector } from 'react-redux'
import { selectBalanceEth } from '../../../modules/web3/selectors'
import { Strong, TypographyItemProps } from '../Typeography'
import { StyledThemedButton } from '../../ThemedButton/styles'
import styled from 'styled-components'
import { amountFromWei } from '../../../utils/amount'
import { Box } from '../../UI/Box'
import { useDynamicContext } from '@dynamic-labs/sdk-react-core'
import { useHistory, useLocation } from 'react-router-dom'
import { selectCurrentSeasonProgress } from '../../../modules/seasons/selectors'
import { useShouldShowForThreshold } from '../../../theme'
import { ComponentType } from 'react'

function WalletActiveButton({ invertColors }: { invertColors?: boolean }) {
  const { setShowDynamicUserProfile } = useDynamicContext()
  const isAtLeastMediumDisplaySize = useShouldShowForThreshold('medium')
  const { push } = useHistory()

  const { tickets: currentSeasonTicketsBalance } = useSelector(
    selectCurrentSeasonProgress,
  ) ?? { tickets: '0' }

  const { pathname } = useLocation()
  const isSeasonPage = pathname.includes('season')


  const showRaffleTickets = isSeasonPage
  const showEthBalance = isAtLeastMediumDisplaySize || !showRaffleTickets

  return (
    <MinWidthContainer>
      <Box ac g={8}>
        {showRaffleTickets && (
          <WalletButtonActive
            onClick={() => push('/season')}
            $styleType={invertColors ? 'tertiary-invert' : 'tertiary'}
            noHover
          >
            <Box ac g={6}>
              <img
                src="/img/icons/raffle-ticket.svg"
                alt="raffle ticket icon"
                width={20}
                height={20}
              />
              <Box>
                <Strong s="M" color="text-secondary">
                  {currentSeasonTicketsBalance}
                </Strong>
              </Box>
            </Box>
          </WalletButtonActive>
        )}
        {showEthBalance && (
          <WalletButtonActive
            onClick={() => setShowDynamicUserProfile(true)}
            $styleType={invertColors ? 'tertiary-invert' : 'tertiary'}
          >
            <EthBalance />
          </WalletButtonActive>
        )}
      </Box>
    </MinWidthContainer>
  )
}

export function useEthBalance() {
  const ethBalance = useSelector(selectBalanceEth)

  const formatEth = (value: string, decimalPlaces = 4) => {
    const numStr = value.toString()
    const [integerPart, fractionalPart] = numStr.split('.')

    if (fractionalPart && fractionalPart.length > decimalPlaces) {
      return `${integerPart}.${fractionalPart.substring(0, decimalPlaces)}`
    }

    return numStr
  }

  const ethBalanceInEth = amountFromWei(ethBalance).toString()
  const ethBalanceUpto4DP = Number(formatEth(ethBalanceInEth)) ?? 0

  return ethBalanceUpto4DP
}

export function EthBalance(
  {
    s = 'M',
    iconSize = 20
  }: {
    s?: TypographyItemProps['s'];
    iconSize?: number
  }
) {
  const ethBalance = useEthBalance()

  return (
    <Box ac g={6}>
      <img
        src="/img/icons/chains/base.svg"
        alt="base icon"
        width={iconSize}
        height={iconSize}
      />
      <Box>
        <Strong s={s} color="text-secondary">
          {ethBalance} ETH
        </Strong>
      </Box>
    </Box>
  )
}

const MinWidthContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}px) {
    min-width: 142px;
  }
`

const WalletButtonActive = styled(StyledThemedButton) <{ noHover?: boolean }>`
  padding: 7px 10px 7px 7px;
  height: 40px;
  gap: var(--units-6, 6px);
  background: var(--surface-primary, #080808);
  border-radius: var(--units-88, 88px);
  border: 1px solid var(--stroke-secondary, #333);
  .separator {
    width: 1px;
    align-self: stretch;
    background: var(--stroke-secondary);
  }
`

export default WalletActiveButton
